<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout
          align-center
          justify-center
          row
          wrap
        >
          <v-flex
            xs12
            class="mx-1 mb-1 pa-0"
          >
            <main-sub-page-toolbar icon="mdi-cash-multiple">{{ $t("dashboardCardModulePhotoOrderPricesButtonTitle") }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex
            xs12
            class="mx-1 mb-1 pa-0 animated fadeIn"
          >
            <v-card
              class="#505050--text mb-12"
              :class="getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'"
              :style="getTheme() == 'dark' ? 'border: 1px solid darkgray; background-color: whitesmoke' : 'border: none; background-color: white'"
            >
              <v-card-title v-if="$store.state.storeImageSize.imageSize.length > 0">{{ $t("dashboardCardModulePhotoOrderUserSubTitle") }}</v-card-title>
              <v-card-text v-if="$store.state.storeImageSize.imageSize.length > 0">
                <v-simple-table
                  dense
                  style="border: 1px solid lightgray; max-width: 600px;"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">{{ $t("settingsImageSizeGridHeaderNameTitle") }}</th>
                        <th class="text-center">{{ $t("settingsImageSizeGridHeaderPriceTitle") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in $store.state.storeImageSize.imageSize.slice().sort((a, b) => a.price - b.price)"
                        :key="item.name"
                      >
                        <td>{{ item.name }}</td>
                        <td class="text-center">{{ price(item.price) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-title
                v-if="$store.state.storeImageDiscount.imageDiscount.filter(x => x.price > 0 && x.price < 100).length > 0"
                class="pt-0 mt-0"
              >{{ $t("dashboardCardSuperAdminImageDiscounts") }}</v-card-title>
              <v-card-text v-if="$store.state.storeImageDiscount.imageDiscount.filter(x => x.price > 0 && x.price < 100).length > 0">
                <v-simple-table
                  dense
                  style="border: 1px solid lightgray; max-width: 600px;"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">{{ $t("settingsImageDiscountsGridHeaderQuantityTitle") }}</th>
                        <th class="text-center">{{ $t("settingsImageDiscountsGridHeaderDiscountTitle") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in $store.state.storeImageDiscount.imageDiscount.filter(x => x.price > 0 && x.price < 100).slice().sort((a, b) => a.price - b.price)"
                        :key="item.name"
                      >
                        <td>{{ item.quantity }}</td>
                        <td class="text-center">{{ percent(item.price) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-title
                v-if="$store.state.storePaperType.paperType.length > 0"
                class="pt-0 mt-0"
              >{{ $t("dashboardCardSuperAdminPaperType") }}</v-card-title>
              <v-card-text v-if="$store.state.storePaperType.paperType.length > 0">
                <v-simple-table
                  dense
                  style="border: 1px solid lightgray; max-width: 600px;"
                >
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">{{ $t("settingsPaperTypeGridHeaderPaperTypeTitle") }}</th>
                        <th class="text-center">{{ $t("settingsPaperTypeGridHeaderPriceTitle") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in $store.state.storePaperType.paperType.slice().sort((a, b) => a.price - b.price)"
                        :key="item.paperType"
                      >
                        <td>{{ item.paperType }}</td>
                        <td class="text-center">{{ percent(item.price) }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-text
                v-if="Number($store.state.storeClient.client.modules.modulePhotoOrder.minOrder) > 0"
                class="caption pt-0"
              >{{ $t("userCartModPhotoOrdersMinOrderError") }} {{ price($store.state.storeClient.client.modules.modulePhotoOrder.minOrder) }}.</v-card-text>
              <v-card-text
                v-if="Number($store.state.storeClient.client.modules.modulePhotoOrder.taxPct) > 0"
                class="caption pt-0"
              >{{ $t("userOrdersIncludesTax") }} {{ $store.state.storeClient.client.environmentSettings.taxTitle }}.</v-card-text>
            </v-card>
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'home' })"
          ></simple-navigation-button>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";

export default {
  name: "userImagePrices",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    SimpleNavigationButton,
  },
};
</script>
